import { Props_SnippetImageContent } from './ImageContent.props'
import { Legacy_CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'


const SnippetImageContent = (props: Props_SnippetImageContent) => {
    const { snippet, heading, image, content, repeatable_link, link } = props

    const classHeadingVisibility: string = heading.visibility?.value ? `snippet-content-column__heading--${heading.visibility.value}` : ''
    const classSnippetLayout = `snippet-image-content--${snippet.layout?.value}`
    const classLinkAlignment = link.alignment?.value ? `snippet-image-content__button-container--${link.alignment.value}` : ''
    const classBackground = snippet.background?.value ? `snippet-image-content--bg-${snippet.background.value}` : ''

    return (
    <section className={`snippet-image-content ${classSnippetLayout} ${classBackground}`}>
        <div className="snippet-image-content__container">
            <div className="snippet-image-content__container-image">
                <img
                    loading="lazy"
                    src={image.src?.value}
                    className="snippet-image-content__image"
                    height="360"
                    width="600"
                    alt={image.alt?.value ? image.alt.value : ''}
                />
            </div>
            <div className="snippet-image-content__container-content">
                <h2 className={`snippet-image-content__heading ${classHeadingVisibility}`}>{heading.content?.value}</h2>
                <div className="snippet-image-content__content">
                    { Legacy_CompileMarkdown(content.content?.value || '') }
                </div>

               <div className={`snippet-image-content__button-container ${classLinkAlignment}`}>
                    { repeatable_link.map((link, index) => (
                        <div key={index + (link.linkHref?.value || '')} className="snippet-image-content__link">
                                <SnippetLink 
                                    linkStyles={link.linkStyle?.value} 
                                    className="snippet-image-content__link" 
                                    url={link.linkHref?.value} 
                                    openInNewTab={link.linkTarget?.value === "true"}
                                    rel={link.linkTarget?.value === "true" ? 'noopener noreferrer' : undefined} 
                                >
                                    {link.linkText?.value}
                                </SnippetLink>
                        </div>
                    ))}
                </div>

                </div>
        </div>
    </section>
    )
}

export default SnippetImageContent